<template>
    <div class="grid grid-cols-4 xl:grid-cols-5 gap-4 h-screen">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4 col-span-4 h-fit pb-5">
        <div class="w-full gap-4" v-if="seriesStatusTask">
<!--          {{ $t('Currency') }}-->
          <vx-card>
            <div class="font-bold text-xl">Task Report</div>
<!--            <div class="flex justify-between">-->
<!--           -->
<!--              <a-dropdown>-->
<!--                <a-menu slot="overlay">-->
<!--                  <a-menu-item key="1"> Last Week </a-menu-item>-->
<!--                  <a-menu-item key="2"> Last Month </a-menu-item>-->
<!--                  <a-menu-item key="3"> Last Year </a-menu-item>-->
<!--                </a-menu>-->
<!--                <a-button type="primary"> Last Week  <a-icon type="down" /> </a-button>-->
<!--              </a-dropdown>-->
<!--            </div>-->
            <template v-if="loading">
              <a-skeleton active />
            </template>
            <VueApexCharts v-else type="bar" :options="chartOptionsStatusTask" :series="seriesStatusTask" class="mt-5"/>
          </vx-card>
        </div>
        <div class="w-full h-full" >
          <vx-card class="h-full">
            <div class="font-bold text-xl">Generate Task</div>
<!--            <div class="flex justify-between">-->
<!--         -->
<!--              <a-dropdown>-->
<!--                <a-menu slot="overlay">-->
<!--                  <a-menu-item key="1"> Last Week </a-menu-item>-->
<!--                  <a-menu-item key="2"> Last Month </a-menu-item>-->
<!--                  <a-menu-item key="3"> Last Year </a-menu-item>-->
<!--                </a-menu>-->
<!--                <a-button type="primary"> Last Week  <a-icon type="down" /> </a-button>-->
<!--              </a-dropdown>-->
<!--            </div>-->
            <template v-if="loading">
              <a-skeleton active />
            </template>
            <template v-else>
              <div class="block m-auto text-center mt-10">
                <div class="flex flex-col space-y-2">
                  <div v-if="generate_task" class="font-semibold text-3xl">{{ generate_task.pending + generate_task.progress + generate_task.review + generate_task.complete }}</div>
                  <div class="text-3xl">Tasks</div>
                </div>
              </div>
              <div v-if="generate_task" class="vx-row mt-5">
                <div class="vx-col w-full mb-3">
                  <div class="flex justify-between">
                    <p>Pending</p>
                    <div>{{ generate_task.pending }}</div>
                  </div>
                  <vs-progress class="block mt-1" :height="5" :percent="generate_task.pending" color="primary"></vs-progress>
                </div>
                <div class="vx-col w-full mb-3">
                  <div class="flex justify-between">
                    <p>Progress</p>
                    <div>{{ generate_task.progress }}</div>
                  </div>
                  <vs-progress class="block mt-1" :height="5" :percent="generate_task.progress" color="warning"></vs-progress>
                </div>
                <div class="vx-col w-full mb-3">
                  <div class="flex justify-between">
                    <p>Review</p>
                    <div>{{ generate_task.review }}</div>
                  </div>
                  <vs-progress class="block mt-1" :height="5" :percent="generate_task.review" color="danger"></vs-progress>
                </div>
                <div class="vx-col w-full mb-3">
                  <div class="flex justify-between">
                    <p>Completed</p>
                    <div>{{ generate_task.complete }}</div>
                  </div>
                  <vs-progress class="block mt-1" :height="5" :percent="generate_task.complete" color="success"></vs-progress>
                </div>
              </div>
            </template>
          </vx-card>
        </div>
        <vx-card class="w-full">
          <div class="font-bold text-xl">Recent Activity</div>
<!--          <div class="flex justify-between">-->
<!--            <a-dropdown>-->
<!--              <a-menu slot="overlay">-->
<!--                <a-menu-item key="1"> Last Week </a-menu-item>-->
<!--                <a-menu-item key="2"> Last Month </a-menu-item>-->
<!--                <a-menu-item key="3"> Last Year </a-menu-item>-->
<!--              </a-menu>-->
<!--              <a-button type="primary"> Last Week  <a-icon type="down" /> </a-button>-->
<!--            </a-dropdown>-->
<!--          </div>-->
          <template v-if="loading">
            <a-skeleton active />
          </template>
          <div v-else>
            <div class="grid grid-cols-4 place-content-between place-items-center py-3 mt-5 font-semibold" style="border-bottom: 1px solid rgb(229 229 229)">
              <div class="place-self-start col-span-2">Activity</div>
              <div>Duration</div>
              <div>Time</div>
            </div>
            <div class="overflow-auto" style="height: 400px">
              <div v-for="(time,ind) in time_line" class="grid grid-cols-4 place-content-center py-4" :style="{ 'border-bottom':ind !== time_line.length - 1 ? '1px solid rgb(229 229 229)' : '' }">
                  <div class="flex items-center space-x-2 col-span-2">
                    <a-avatar>
                      <template slot="icon">
                        <feather-icon :icon="iconTime(time.action)" svg-classes="text-white w-4 h-4"></feather-icon>
                      </template>
                    </a-avatar>
                    <div>{{ pastTenseOf[time.action] }} a {{ removeUnderscores(time.model) }}</div>
                  </div>
                  <div class="place-self-center">{{ momentCreate(time.created_at_formatted) }}</div>
                  <div class="place-self-center">{{ moment(time.created_at.$date) }}</div>
                </div>
            </div>
          </div>
        </vx-card>
        <vx-card class="w-full h-full">
          <div class="font-bold text-xl mb-5">Invoices</div>
          <template v-if="loading">
            <a-skeleton/>
          </template>
          <template v-else>
            <div class="flex flex-col justify-between space-y-4">
              <div v-for="bill in bills" type="link" class="cursor-pointer flex justify-between items-center space-x-2 p-3 rounded" style="border: 1px solid rgb(229, 229, 229)">
                <div class="flex items-center space-x-2">
                  <div class="rounded-full w-10 h-10" :style="{ background: bgStatusBillDash(bill.title) }">
                    <feather-icon
                      icon="CheckCircleIcon"
                      svg-classes="text-white w-5 h-5"
                      :style="{ top:'25%', left:'23%' }"
                    >
                    </feather-icon>
                  </div>
                  <div class="flex flex-col space-y-2">
                    <div class="font-medium text-lg">{{ bill.title }}</div>
                    <div @click="billFilterSts(bill)" :style="{ color: bgStatusBillDash(bill.title) }">Show bills</div>
                  </div>
                </div>
                <div>{{ bill.count }}</div>
              </div>
            </div>
          </template>
        </vx-card>
      </div>
      <div class="relative h-full pb-5 hidden xl:block">
        <div class="rounded h-full flex flex-col gap-3" style="background: linear-gradient(109.6deg, rgb(9, 9, 121) 11.2%, rgb(144, 6, 161) 53.7%, rgb(0, 212, 255) 100.2%);">
          <vx-card class="events-day mt-2">
            <a-spin :spinning="skeleton" :indicator="indicator">
              <template v-if="listToday">
                <template v-if="listToday.events.length">
                  <div class="text-medium text-white">Today Events:</div>
                  <div v-for="(event,i) in listToday.events" :key="i">
                    <a-badge :color="statusColorEvent(event.labels)" :text="event.title" class="ml-2 text-badge-dash-white"/>
                  </div>
                </template>
                <template v-if="listToday.tasks.length">
                  <div class="text-medium text-white">Today Tasks:</div>
                  <div v-for="(task,i) in listToday.tasks" :key="i" class="text-white ml-2">
                    {{ task.title }}
                  </div>
                </template>
                <template v-if="listToday.events.length === 0 && listToday.tasks.length === 0">
                  <div class="text-white">No Task Or Event</div>
                </template>
              </template>
            </a-spin>
          </vx-card>
          <div :style="{ width: '100%', borderRadius: '5px',padding:'0 10px',zIndex: 1, 'overflow-x': 'hidden' }">
            <a-calendar :fullscreen="false" @change="handleCalenderChange"/>
          </div>
          <img src="../assets/images/dashboard/dashbord-clock.svg" class="w-full" id="clock" />
        </div>
      </div>
      <a-modal title="Expired Account" :visible="visible" @cancel="visible = false" :width="600">
        <p class="font-semibold">Dear valued customer,</p>
        Your IRALEX subscription will be expiring in <span class="font-bold">{{ expiredAccountModal }} days</span>.
        <p>Kindly arrange for payment promptly to avoid service interruption.</p>
        <a-button type="danger" ghost @click="redirectPayment">Pay Now</a-button>
      </a-modal>
    </div>
</template>

<script>
  import axios from "@/axios";
  import VueApexCharts from 'vue-apexcharts'
  import mixin from './mixin/mixin'
  import moment from 'moment'

  export default {
    components: {
      VueApexCharts
    },
    mixins:[mixin],
    data(){
      return {
        visible    : false,
        pastTenseOf: {
          'create': 'created',
          'issue': 'issued',
          'edit': 'edited',
          'get': 'got',
          'remove': 'removed',
        },
        bills: null,
        loading: true,
        skeleton: false,
        chartOptionsStatusTask:{
          xaxis: {
            categories: ['Incomplete','Today','Overdue','Upcoming Week']
          },
          colors:['#3A3DBE'],
          plotOptions: {
            bar: {
              borderRadius: 3
            }
          },
        },
        seriesStatusTask: [],
        time_line: [],
        generate_task: null,
        listToday: null,
        indicator: <a-icon type="loading" style="font-size: 24px" spin />,
      }
    },
    methods:{
      async getDataDashboard(){
        try{
          this.loading   = true
          this.events = []
          const { data } = await axios.get('/dashboard/')
          const statusTitleBill = ['Unpaid','Approved','Draft','Today','Overdue']
          this.bills = Object.values(data.bills).map((item,i)=> ({ title: statusTitleBill[i], count: item }))
          this.seriesStatusTask = [{
            name:'Task Status',
            data: Object.values(data.tasks)
          }]
        }catch (e) {
          throw e
        }finally {
          this.loading = false
        }
      },
      async getStatusTasks() {
        try{
          this.loading = true
          const { data } = await axios.get('report/stats/task')
          const total_task = data.next.length + data.past.length + data.complete.length
          this.seriesStatusTask = [{
            name:'Task Status',
            data: [total_task,data.next.length,data.past.length,data.complete.length]
          }]
        }catch (e) {
          throw e
        }finally {
          this.loading = false
        }
      },
      async getGenerateTasks() {
        try{
          this.loading = true
          const { data } = await axios.get('report/stats/task-status')
          this.generate_task = data.result.map(task =>({
            pending : task.pending  ? task.pending.status__count  : 0,
            progress: task.progress ? task.progress.status__count : 0,
            review  : task.review   ? task.review.status__count   : 0,
            complete: task.complete ? task.complete.status__count : 0
          })).reduce((first, last)=> ({
            pending : first.pending  + last.pending,
            progress: first.progress + last.progress,
            review  : first.review   + last.review,
            complete: first.complete + last.complete
          }))
        }catch (e) {
          throw e
        }finally {
          this.loading = false
        }
      },
      async getTimeLine(){
        try{
          this.loading = true
          const {data} = await axios.post('/timeline/firm/')
          this.time_line = data
        }catch (e) {
          if (e.status !== 419)
            this.$message.error('Error receiving data.')
        }finally {
          this.loading = false
        }
      },
      async handleCalenderChange(e) {
        try {
          this.skeleton = true
          const { data } = await axios.post('/calendar/event/query/',{ query:[{ field: 'start', condition:'like',value:  moment(e ? e._d : undefined).format('YYYY-MM-DD') }] })
          const tasks = await axios.post('/task/query/',{ query:[{condition: "=", field: "due_date", value: moment().format('YYYY-MM-DD')}] })
          this.listToday = { events: data.rows, tasks: tasks.data.rows }
        }catch (e) {
          throw new Error(e)
        }finally {
          this.skeleton = false
        }
      },
      momentCreate(date){
        return moment(date).format('HH:mm')
      },
      bgTime(action){
        if (action === 'edit')    return '#3A3DBE'
        if (action === 'remove')  return '#FF0000'
        if (action === 'create')  return '#A991EE'
        if (action === 'get')     return '#42ba96'
        if (action === 'send')    return '#7c69ef'
      },
      iconTime(action){
        if (action === 'edit')    return 'EditIcon'
        if (action === 'remove')  return 'TrashIcon'
        if (action === 'create')  return 'PlusIcon'
        if (action === 'get')     return 'ListIcon'
        if (action === 'send')    return 'MessageCircleIcon'
      },
      bgStatusBillDash(title){
        if (title === 'Overdue')   return '#FF9494'
        if (title === 'Approved')  return '#1C7C1B' //'#17954C'
        if (title === 'Draft')     return '#3A3DBE'
        if (title === 'Today')     return '#42ba96'
        if (title === 'Unpaid')    return '#DDA200' // '#FCBE15'
      },
      statusColorEvent(label) {
        if (label === '1') return '#3A3DBE'
        if (label === '2') return 'rgba(40,199,111,1)'
        if (label === '3') return 'rgba(255,159,67,1)'
        if (label === '4') return 'rgba(234,84,85,1)'
      },
      removeUnderscores(theString) {
        return theString.replace(/_/g, ' ')
      },
      billFilterSts(item){
        this.$router.push({ path: '/billing', query: { status: item.title,count: item.count } })
      }
    },
    created() {
      this.getDataDashboard()
      // this.getStatusTasks()
      this.getGenerateTasks()
      this.getTimeLine()
      this.handleCalenderChange()
      if(this.expiredAccountModal <= 10)
        this.visible = true
    },
  }
</script>

<style>
  .h-fit{
    height: fit-content;
  }
  .bg-test{
    background: red;
  }
  #clock{
    position: absolute;
    bottom: 30px;
    padding: 0 10px;
  }
  .ant-fullcalendar-header {
    background: #3A3DBE;
    border-radius: 4px 4px 0 0;
    height: 70px;
    padding: 20px 0;
    text-align: center;
  }
  .ant-fullcalendar-calendar-body {
    background: white;
    border-radius: 0 0 4px 4px;
  }
  .events-day {
    background: none !important;
    backdrop-filter: blur(100px);
    box-shadow: rgba(0, 0, 0, 0.25) 0px 25px 50px -12px;
    width: 94%;
    margin: 0 auto;
  }
  .text-badge-dash-white .ant-badge-status-text {
    color: white !important;
  }
</style>

